/* eslint-disable no-unused-expressions,object-curly-newline,no-unused-vars */
/* global G */
import { asyncPipeSpread } from 'lib/util'
import find from 'lib/sequence/component/children/find'

/**
 * If the model's requesterOrg attribute has a cache value, marks the step as completed and sets the
 * attribute's name and businessRole to be shown as the step title and subtitle, otherwise sets the
 * step as non-completed and non-confirmed and clears its title and subtitle.
 *
 * @param {Gaia.AppModule.Spec} module  the current module composition object
 * @returns {function(*, ...[*]): Promise<*[]>}
 */
const setStepState = module => async (components, ...args) => {
  const model = module[G.MODEL]
  const { firstName, lastName, businessRole } = model[G.CHILDREN]
  const { component: step } = components
  const stepState = step[G.STATE]

  if (model[G.CACHE]) {
    stepState.completed = true
    // filling step's title and subtitle with model data
    stepState.title = `${firstName[G.CACHE]} ${lastName[G.CACHE]}`
    stepState.subtitle = businessRole[G.CACHE]
  } else {
    // setting step as incomplete and unconfirmed
    stepState.completed = false
    stepState.confirmed = false
    // clearing step's title and subtitle
    stepState.title = ''
    stepState.subtitle = ''
  }

  return args
}

/**
 * Contact identification step.
 *
 * If no contact is selected, displays a list to search among them and a button to add a new
 * one. Otherwise, sets the step as complete and displays the selected contact's data together
 * with buttons to edit it, to clear the confirm view and to go to the next step.
 *
 * @param {Gaia.AppModule.Spec} module  the current module composition object
 * @returns {function(*=): function(...[*]): Promise<*[]>}
 */
export default module => component => async (...args) => await asyncPipeSpread(
  setStepState(module),
)(find(component), ...args)
